import { useEffect } from 'react';

const AdminAssets = () => {
  useEffect(() => {
    // CSS files
    const styles = [
      '/admin/plugins/bootstrap/css/bootstrap.css',
      '/admin/plugins/node-waves/waves.css',
      '/admin/plugins/animate-css/animate.css',
      '/admin/css/style.css',
      'https://fonts.googleapis.com/css?family=Roboto:400,700&subset=latin,cyrillic-ext',
      'https://fonts.googleapis.com/icon?family=Material+Icons'
    ];

    styles.forEach(href => {
      if (!document.querySelector(`link[href="${href}"]`)) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = href;
        document.head.appendChild(link);
      }
    });

    // JS files in correct order
    const scriptList = [
      '/admin/plugins/jquery/jquery.min.js',
      '/admin/plugins/bootstrap/js/bootstrap.js',
      '/admin/plugins/node-waves/waves.js',
      '/admin/plugins/jquery-validation/jquery.validate.js',
      '/admin/js/admin.js',
      '/admin/js/pages/examples/sign-in.js',
      '/admin/plugins/jquery-datatable/jquery.dataTables.js',
      '/admin/plugins/jquery-datatable/skin/bootstrap/js/dataTables.bootstrap.js',
      '/admin/plugins/jquery-datatable/extensions/export/dataTables.buttons.min.js',
      '/admin/plugins/jquery-datatable/extensions/export/buttons.flash.min.js',
      '/admin/plugins/jquery-datatable/extensions/export/jszip.min.js',
      '/admin/plugins/jquery-datatable/extensions/export/pdfmake.min.js',
      '/admin/plugins/jquery-datatable/extensions/export/vfs_fonts.js',
      '/admin/plugins/jquery-datatable/extensions/export/buttons.html5.min.js',
      '/admin/plugins/jquery-datatable/extensions/export/buttons.print.min.js',
      '/admin/js/pages/tables/jquery-datatable.js'
    ];

    const loadScriptSequentially = async (srcList) => {
      for (let src of srcList) {
        await new Promise((resolve, reject) => {
          if (document.querySelector(`script[src="${src}"]`)) {
            resolve();
            return;
          }
          const script = document.createElement('script');
          script.src = src;
          script.async = false;
          script.onload = resolve;
          script.onerror = reject;
          document.body.appendChild(script);
        });
      }
    };

    loadScriptSequentially(scriptList).catch(err => {
      console.error("Error loading admin scripts", err);
    });

  }, []);

  return null;
};

export default AdminAssets;
